import { pathAsModuleName } from 'src/helpers/string'

const filtersContext = require.context('../filters', true, /\.js/)

/**
 * load all files (filter) in the filters directory recursively.
 * And register them as global Vue filter
 */
export default ({ Vue }) => {
  filtersContext
    .keys()
    .forEach(fileName => {
      const filter = filtersContext(fileName).default || filtersContext(fileName)
      Vue.filter(pathAsModuleName(fileName), filter)
    })
}
